export const countries = [
    {
        id: 1,
        code: 'EG',
        label: 'Egypt',
        phone: '20',
        rules: {
            pattern: /^20\d{10}$/, // إذا أدخل المستخدم الكود مع الرقم
            length: 10, // الطول بدون الكود
            example: '1012345678'
        }
    },
    {
        id: 2,
        code: 'SA',
        label: 'Saudi Arabia',
        phone: '966',
        rules: {
            pattern: /^966\d{9}$/,
            length: 9,
            example: '512345678'
        }
    },
];
